import React, { CSSProperties } from "react";
import { Input } from "antd";
import "./DefaultInput.css";

interface IDefaultInput {
	label?: string;
	placeholder?: string;
	width?: number;
	value?: any;
	onChange?: (value: any) => void;
	allowClear?: any;
	className?: any;
	prefix?: any;
	suffix?: any;
	addonBefore?: any;
	type?: "text" | "password" | "number";
	required?: boolean;
	disabled?: boolean;
	ref?: any;
	min?: number;
	underLabel?: string;
	status?: any;
	onBlur?: any;
	style?: CSSProperties;
	/**
	 * Control rendered at the right-hand end of the label row — a unit selector, a small action.
	 *
	 * It belongs on the label line rather than above the field: anything stacked above the label
	 * pushes this input down relative to its siblings in a flex row, which is exactly how the
	 * register-order currency switch once broke the alignment of the whole package-data block.
	 * (That switch is now its own field — `CurrencySelectField` — because it was too easy to miss
	 * as an adornment. This slot remains for genuinely secondary controls.)
	 */
	labelExtra?: React.ReactNode;
	/** Hint under the input — a converted amount, a constraint. Does not affect label alignment. */
	hint?: React.ReactNode;
}

const DefaultInput = ({
	label,
	placeholder,
	width,
	value,
	onChange,
	allowClear,
	className,
	prefix,
	suffix,
	type = "text",
	addonBefore,
	required,
	disabled = false,
	ref,
	min,
	underLabel,
	onBlur,
	status,
	style,
	labelExtra,
	hint,
}: IDefaultInput) => {
	const numberInputOnWheelPreventChange = (e: any) => {
		e.target.blur();

		e.stopPropagation();

		setTimeout(() => {
			e.target.focus();
		}, 0);
	};
	return (
		<div className="flex flex-col items-start gap-1">
			{labelExtra ? (
				// Label and control share one line, so the field keeps the same top edge as
				// every other input beside it.
				<div className="flex items-center justify-between gap-3 w-full -mb-1 min-h-[24px]">
					<label>{label}</label>
					{labelExtra}
				</div>
			) : (
				<label className="w-42 -mb-1">{label}</label>
			)}
			{underLabel && (
				<label className="w-42" style={{ fontSize: 12 }}>
					{underLabel}
				</label>
			)}
			<Input
				type={type}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				allowClear={allowClear}
				className={`default-input ${className}`}
				prefix={prefix}
				suffix={suffix}
				addonBefore={addonBefore}
				required={required}
				disabled={disabled}
				min={min}
				ref={ref}
				onBlur={onBlur}
				status={status}
				style={style}
				//@ts-ignore
				onWheel={numberInputOnWheelPreventChange}
			/>
			{hint}
		</div>
	);
};

export default DefaultInput;
